import { render, staticRenderFns } from "./h5ConfigLog.vue?vue&type=template&id=2b2b526c&scoped=true"
import script from "./h5ConfigLog.vue?vue&type=script&lang=js"
export * from "./h5ConfigLog.vue?vue&type=script&lang=js"
import style0 from "./h5ConfigLog.vue?vue&type=style&index=0&id=2b2b526c&prod&lang=css"
import style1 from "./h5ConfigLog.vue?vue&type=style&index=1&id=2b2b526c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b526c",
  null
  
)

export default component.exports